<script lang="ts" setup>
import { type VragenSbiCodesSbiBeschrijvingDto } from '@services/vragen-public/api';
import { toTypedSchema } from '@vee-validate/zod';
import { useField } from 'vee-validate';
import { inject, ref } from 'vue';
import { z } from 'zod';
import translation from 'zod-i18n-map/locales/nl/zod.json';
import SbiOpzoek from '@shared/form/SbiOpzoek/SbiOpzoek.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { type SbiCodeEvent } from '@shared/form/SbiOpzoek/types';
import {
  hideRequiredAsteriskInjectionKey,
  isDisabledInjectionKey,
  isReadonlyInjectionKey,
} from '../keys';

const props = defineProps<{
  lookupDetailsFn: (value: string) => Promise<VragenSbiCodesSbiBeschrijvingDto | undefined>;
}>();

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });
const { value: hideRequiredAsteriskParent } = inject(hideRequiredAsteriskInjectionKey, {
  value: ref(false),
});

const sbicodeField = useField(
  'sbicode',
  toTypedSchema(z.string().min(1, translation.errors.invalid_type_received_undefined).max(6)),
);

function sbicodeValueUpdated(value?: SbiCodeEvent | undefined) {
  if (!value?.rawSbiCode) {
    return;
  }

  sbicodeField.value.value = value?.rawSbiCode;
}

const fieldlId = 'relatiegegevens-relatie-sbicode';
</script>

<template>
  <FieldRowV2
    :errors="sbicodeField.errors.value"
    label="SBI zoals geregistreerd in de KVK"
    :required="!hideRequiredAsteriskParent && !hasReadonlyParent"
    :label-for="fieldlId"
    v-bind="$attrs"
  >
    <SbiOpzoek
      :disabled="hasDisabledParent"
      :readonly="hasReadonlyParent"
      :has-error="!!sbicodeField.errors.value.length"
      placeholder="Zoek op SBIcode / omschrijving"
      :search-throttle="4"
      :lookup-details="props.lookupDetailsFn"
      :value="sbicodeField.value.value"
      @update:value="sbicodeValueUpdated"
      :id="fieldlId"
    />
  </FieldRowV2>
</template>
